<template>
  <v-container fluid class="asistencia-page pa-4 pa-md-6">
    <v-card flat outlined class="page-card">
      <div class="page-header px-4 px-md-5 pt-4 pb-3">
        <div class="page-header__text">
          <h1 class="page-title">Participación alumnos</h1>
          <p v-if="ciclo" class="page-subtitle mb-0">
            {{ ciclo.ciclo }}
            <span class="page-subtitle__dot">·</span>
            {{ cargarGrupos ? 'cargando grupos...' : filterGrupos.length + ' grupos' }}
            <span v-if="tablaAsistencia" class="page-subtitle__dot">·</span>
            <span v-if="tablaAsistencia" class="caption grey--text">tabla {{ tablaAsistencia }}</span>
          </p>
          <p v-else class="page-subtitle mb-0">Selecciona un ciclo para cargar tus grupos</p>
        </div>
        <div class="page-actions">
          <v-btn
            class="page-actions__btn"
            outlined
            small
            :disabled="!filterGrupos.length || cargarGrupos"
            @click="exportar()"
          >
            <v-icon left small>mdi-microsoft-excel</v-icon>
            Exportar
          </v-btn>
          <v-btn
            class="page-actions__btn"
            depressed
            small
            color="primary"
            :loading="cargarGrupos"
            :disabled="!ciclo"
            @click="consultar(true)"
          >
            Consultar
          </v-btn>
        </div>
      </div>

      <v-divider></v-divider>

      <v-card-text class="px-4 px-md-5 py-4">
        <v-row dense class="filters-row">
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              v-model="ciclo"
              :items="ciclos"
              label="Ciclo"
              placeholder="Seleccionar ciclo"
              outlined
              dense
              clearable
              hide-details
              return-object
              :loading="cargandoCiclos"
              :disabled="cargarGrupos"
              item-text="ciclo"
              item-value="id_ciclo"
              prepend-inner-icon="mdi-calendar-range"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              v-model="plantel"
              :items="plantelesOpciones"
              label="Plantel"
              outlined
              dense
              clearable
              hide-details
              item-text="texto"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col v-if="mostrarFiltroTeacher" cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              v-model="teacherFiltro"
              :items="teachersLista"
              label="Teacher"
              outlined
              dense
              clearable
              hide-details
              item-text="nombre_completo"
              item-value="id_teacher_lms"
              prepend-inner-icon="mdi-account-tie"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              v-model="search"
              label="Buscar grupo"
              placeholder="Nombre del grupo..."
              outlined
              dense
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2" lg="2">
            <v-select
              v-model="curso"
              :items="opcionesFrecuencia"
              label="Frecuencia"
              outlined
              dense
              hide-details
              clearable
              item-text="texto"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="6" sm="4" md="2" lg="2">
            <v-select
              v-model="modalidad"
              :items="opcionesModalidad"
              label="Modalidad"
              outlined
              dense
              hide-details
              clearable
              item-text="texto"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4" lg="2">
            <v-autocomplete
              v-model="nivel"
              :items="nivelesUnicos"
              label="Nivel"
              outlined
              dense
              hide-details
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              v-model="horarioFiltro"
              :items="horariosUnicos"
              label="Horario"
              placeholder="Todos los horarios"
              outlined
              dense
              hide-details
              clearable
              prepend-inner-icon="mdi-clock-outline"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <div class="d-flex flex-wrap align-center mt-3 mb-1" style="gap: 8px;">
          <v-chip small :outlined="filtroLista !== 'todos'" :color="filtroLista === 'todos' ? 'primary' : ''" @click="filtroLista = 'todos'">Todos ({{ conteosLista.todos }})</v-chip>
          <v-chip small :outlined="filtroLista !== 'pendiente'" color="error" @click="filtroLista = 'pendiente'">Sin lista ({{ conteosLista.pendiente }})</v-chip>
          <v-chip small :outlined="filtroLista !== 'pasada'" color="success" @click="filtroLista = 'pasada'">Con lista ({{ conteosLista.pasada }})</v-chip>
          <v-chip small :outlined="filtroLista !== 'no_inicia'" color="grey" @click="filtroLista = 'no_inicia'">Aún no inicia ({{ conteosLista.no_inicia }})</v-chip>
        </div>

        <v-alert v-if="avisoGrupos" dense outlined type="info" class="mt-2 mb-3">
          {{ avisoGrupos }}
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="filterGrupos"
          item-key="id_grupo_lms"
          :item-class="claseFilaGrupo"
          class="asistencia-table mt-2"
          height="calc(100vh - 360px)"
          dense
          fixed-header
          :search="search"
          multi-sort
          :loading="cargarGrupos"
          loading-text="Cargando grupos del ciclo..."
          :footer-props="{
            'items-per-page-options': [15, 30, 50, -1],
            showFirstLastPage: true,
          }"
        >
          <template v-slot:progress>
            <v-progress-linear color="primary" indeterminate height="3"></v-progress-linear>
          </template>
          <template v-slot:item.horario="{ item }">
            <span class="text-body-2">{{ item.horario || '—' }}</span>
          </template>
          <template v-slot:item.teacher_hoy="{ item }">
            <span class="text-body-2">{{ item.teacher_hoy || item.teachers_nombre || '—' }}</span>
          </template>
          <template v-slot:item.cant_alumnos="{ item }">
            <span class="text-body-2">{{ item.cant_alumnos }}</span>
          </template>
          <template v-slot:item.asistencias_hoy="{ item }">
            <span class="text-body-2">{{ Number(item.asistencias_hoy) || 0 }}</span>
          </template>
          <template v-slot:item.faltas_hoy="{ item }">
            <span class="text-body-2">{{ Number(item.faltas_hoy) || 0 }}</span>
          </template>
          <template v-slot:item.lista_pasada="{ item }">
            <v-chip v-if="listaPasada(item)" x-small color="success" text-color="white">Lista</v-chip>
            <v-chip v-else-if="claseIniciadaSinLista(item)" x-small color="error" text-color="white">Pendiente</v-chip>
            <span v-else class="caption grey--text">—</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn text small color="primary" class="px-2" @click="verGrupo(item)">
              <v-icon small left>mdi-account-group</v-icon>
              Ver
            </v-btn>
          </template>
          <template v-slot:no-data>
            <div class="py-8 text-center grey--text text--darken-1">
              <v-icon large color="grey lighten-1" class="mb-2">mdi-table-search</v-icon>
              <div class="body-2">{{ mensajeTablaGrupos }}</div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogGrupo" max-width="820px" scrollable transition="dialog-transition">
      <v-card flat outlined class="dialog-card">
        <div class="dialog-header px-4 py-3">
          <div>
            <div class="dialog-title">Tomar asistencia</div>
            <div v-if="grupo" class="dialog-subtitle">
              {{ grupo.grupo }}
              <span v-if="grupo.horario"> · {{ grupo.horario }}</span>
              <span v-if="grupo.teacher_hoy || grupo.teachers_nombre">
                · {{ grupo.teacher_hoy || grupo.teachers_nombre }}
              </span>
            </div>
          </div>
          <v-btn icon small @click="dialogGrupo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="px-4 py-3">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="fecha"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecha"
                    label="Fecha"
                    outlined
                    dense
                    hide-details
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha"
                  no-title
                  scrollable
                  :allowed-dates="fechasHabiles"
                  :min="fechaMin"
                  :max="fechaMax"
                  color="primary"
                >
                  <v-spacer></v-spacer>
                  <v-btn text small @click="menu = false">Cancelar</v-btn>
                  <v-btn text small color="primary" @click="$refs.menu.save(fecha), getAlumnos(grupo)">
                    Aplicar
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center">
              <span class="caption grey--text mr-3">Leyenda</span>
              <v-chip x-small outlined color="success" class="mr-1">Asistencia</v-chip>
              <v-chip x-small outlined color="error" class="mr-1">Falta</v-chip>
              <v-chip x-small outlined color="orange">Justificación</v-chip>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersAlumnos"
            :items="listaalumnos"
            :items-per-page="listaalumnos.length"
            :item-class="claseFilaAlumno"
            class="asistencia-table dialog-table mt-3"
            hide-default-footer
            :mobile-breakpoint="100"
            dense
          >
            <template v-slot:item.alumno="{ item }">
              <div class="d-flex align-center my-1">
                <div v-if="!item.tipo == 1">
                  <v-avatar size="36" color="transparent" class="mr-2">
                    <avataaars
                      v-if="item.idavatar != null"
                      :accessoriesType="item.accessoriesType"
                      :isCircle="true"
                      :clotheType="item.clotheType"
                      :clotheColor="item.clotheColor"
                      :eyebrowType="item.eyebrowType"
                      :eyeType="item.eyeType"
                      :facialHairColor="item.facialHairColor"
                      :facialHairType="item.facialHairType"
                      :graphicType="item.graphicType"
                      :mouthType="item.mouthType"
                      :skinColor="item.skinColor"
                      :topType="item.topType"
                      :topColor="item.topColor"
                      :hairColor="item.hairColor"
                      :circleColor="'#6fb8e0'"
                    ></avataaars>
                    <avataaars v-else></avataaars>
                  </v-avatar>
                  <span class="text-body-2">{{ item.alumno }}</span>
                </div>
                <div v-else>
                  <span class="text-caption font-weight-medium grey--text text--darken-1">Valor</span>
                </div>
              </div>
            </template>
            <template v-slot:item.asistencia="{ item }">
              <div v-if="!item.tipo == 1">
                <v-radio-group row dense hide-details class="mt-0 pt-0" v-model="item.valor_asistencia">
                  <v-radio color="success" :value="1"></v-radio>
                  <v-radio color="error" :value="2"></v-radio>
                  <v-radio readonly color="orange" :value="4"></v-radio>
                </v-radio-group>
              </div>
              <div v-else>
                <v-radio-group row dense hide-details class="mt-0 pt-0" value="1">
                  <v-radio readonly color="success" value="1"></v-radio>
                  <v-radio readonly color="error" value="1"></v-radio>
                  <v-radio readonly color="orange" value="1"></v-radio>
                </v-radio-group>
              </div>
            </template>
            <template v-slot:item.acciones="{ item }">
              <v-btn
                v-if="mostrarBtnAsistencia && [2, 4].includes(Number(item.valor_asistencia)) && item.alumno !== 'Valor'"
                text
                small
                color="orange darken-2"
                class="px-1"
                @click="justificar(item)"
              >
                {{ Number(item.valor_asistencia) === 4 ? 'Ver justificación' : 'Justificar' }}
              </v-btn>
            </template>
            <template v-slot:item.fecha_pago="{ item }">
              <v-chip v-if="!item.fecha_pago" small outlined color="success" @click="editFechaPago(item)">
                Fecha de reinscripción
              </v-chip>
              <span v-else class="text-body-2">{{ item.fecha_pago }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-btn text small color="grey darken-1" @click="dialogGrupo = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed small color="primary" :disabled="disabled" :loading="loading" @click="enviarAsistencias()">
            <v-icon left small>mdi-content-save-outline</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <JustificarAsistenciaAlumno
      @modal-cerrado="onJustificacionCerrada"
      :modalJustificacion="modalJustificacion"
      :modalEscuela="modalEscuela"
      :modalJustificarAsistencia="modalJustificarAsistencia"
      :modalIdgrupo="modalIdgrupo"
      :modalIderp="modalIderp"
      :modalSesion="modalSesion"
      :modalId_usuario="modalId_usuario"
      :modalFecha="fecha"
    ></JustificarAsistenciaAlumno>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import JustificarAsistenciaAlumno from '@/components/operaciones/alumnos/JustificarAsistenciaAlumno.vue';
import validarErrores from '@/mixins/validarErrores';
import funcionesExcel from '@/mixins/funcionesExcel';
import filtrosAsistencia from '@/mixins/filtrosAsistencia';
import mixinAsistencia from '@/mixins/mixinAsistencia';
import Avataaars from 'vuejs-avataaars';

var PARTICIPACION_CACHE_TTL_MS = 30 * 60 * 1000;
var participacionPersistTimer = null;

function participacionStorageKey(iderp) {
  return 'participacionAlumnos:v1:' + String(iderp || '0');
}

export default {
  name: 'ParticipacionAlumnosTeacher',

  components: {
    Alerta,
    carga,
    Avataaars,
    JustificarAsistenciaAlumno,
  },

  mixins: [validarErrores, funcionesExcel, filtrosAsistencia, mixinAsistencia],

  data: function () {
    return {
      parametros: { dialogError: false, mensaje: '', color: '' },
      respuestaAlerta: false,
      cargar: false,
      cargarGrupos: false,
      cargandoCiclos: false,
      consultaGruposId: 0,
      gruposBasePorCiclo: {},
      asistenciasCache: {},
      fechasCache: {},
      _restaurandoEstado: false,
      _persistReady: false,
      search: '',
      gruposRoles: [],
      mensajeGrupos: '',
      ciclos: [],
      ciclo: null,
      plantel: null,
      teacherFiltro: null,
      teachersLista: [],
      puedeVerTodos: false,
      idTeacherLms: 0,
      tablaAsistencia: 'asistencia_grupo',
      horarioFiltro: null,
      filtroLista: 'todos',
      ahoraMinutos: 0,
      intervaloHora: null,
      headersParticipacion: [
        { text: 'Grupo', value: 'grupo' },
        { text: 'Horario', value: 'horario' },
        { text: 'Teacher', value: 'teacher_hoy' },
        { text: 'Alumnos', value: 'cant_alumnos' },
        { text: 'Asist.', value: 'asistencias_hoy' },
        { text: 'Faltas', value: 'faltas_hoy' },
        { text: 'Lista', value: 'lista_pasada' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      niveles: [],
      nivel: null,
      modalidad: null,
      dialogGrupo: false,
      listaalumnos: [],
      headersAlumnos: [
        { text: 'Alumno', value: 'alumno', sortable: false },
        { text: 'Asistencia', value: 'asistencia', align: 'center', sortable: false, width: '140px' },
        { text: 'Acciones', value: 'acciones', sortable: false, width: '130px' },
      ],
      disabled: false,
      loading: false,
      fecha: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      fechaMin: null,
      fechaMax: null,
      fechas: [],
      grupo: null,
      modalJustificarAsistencia: { status: false },
      modalIderp: 0,
      modalIdgrupo: 0,
      modalEscuela: 0,
      modalId_usuario: 0,
      modalJustificacion: false,
      modalSesion: 0,
      mostrarBtnAsistencia: false,
      opcionesFrecuencia: [
        { id: 1, texto: 'Dominical' },
        { id: 2, texto: 'Sabatino' },
        { id: 3, texto: 'Entre semana' },
      ],
      opcionesModalidad: [
        { id: 1, texto: 'Online' },
        { id: 0, texto: 'Presencial' },
      ],
    };
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    mostrarFiltroTeacher: function () {
      if (this.puedeVerTodos) return true;
      return this.tieneVistaAmpliadaLogin();
    },

    plantelesOpciones: function () {
      var map = {};
      var lista = [];
      this.getGruposBaseLista().forEach(function (g) {
        if (!g || !g.id_plantel || map[g.id_plantel]) return;
        map[g.id_plantel] = true;
        lista.push({ id: g.id_plantel, texto: g.plantel || ('Plantel ' + g.id_plantel) });
      });
      return lista.sort(function (a, b) {
        return String(a.texto).localeCompare(String(b.texto));
      });
    },

    nivelesUnicos: function () {
      var vistos = {};
      return this.niveles.filter(function (n) {
        if (!n || vistos[n]) return false;
        vistos[n] = true;
        return true;
      });
    },

    horariosUnicos: function () {
      var vistos = {};
      var lista = [];
      this.gruposRoles.forEach(function (g) {
        var h = g && g.horario;
        if (!h || vistos[h]) return;
        vistos[h] = true;
        lista.push(h);
      });
      return lista.sort();
    },

    avisoGrupos: function () {
      if (this.mensajeGrupos) return this.mensajeGrupos;
      if (this.gruposRoles.length && !this.filterGrupos.length) {
        return 'Se recibieron grupos, pero los filtros actuales no permiten mostrarlos';
      }
      return '';
    },

    mensajeTablaGrupos: function () {
      if (this.cargarGrupos) return 'Cargando grupos del ciclo...';
      if (this.avisoGrupos) return this.avisoGrupos;
      if (!this.ciclo) return 'Elige un ciclo y pulsa Consultar';
      return 'Sin grupos con los filtros actuales';
    },

    gruposFiltradosBase: function () {
      var grupos = this.gruposRoles.filter(function (el) {
        return el.deleted == 0;
      });

      if (this.nivel) {
        grupos = grupos.filter(function (el) {
          return el.id_nivel == this.nivel;
        }, this);
      }

      if ([0, 1].includes(this.modalidad)) {
        grupos = grupos.filter(function (el) {
          return el.online == this.modalidad;
        }, this);
      }

      if (this.curso == 1) {
        grupos = grupos.filter(function (el) {
          return el.grupo && el.grupo.match('DOMI');
        });
      }
      if (this.curso == 2) {
        grupos = grupos.filter(function (el) {
          return el.grupo && el.grupo.match('SABA');
        });
      }
      if (this.curso == 3) {
        grupos = grupos.filter(function (el) {
          return el.grupo && !el.grupo.match('SABA') && !el.grupo.match('DOMI');
        });
      }

      if (this.horarioFiltro) {
        grupos = grupos.filter(function (el) {
          return el.horario === this.horarioFiltro;
        }, this);
      }

      return grupos;
    },

    conteosLista: function () {
      var grupos = this.gruposFiltradosBase;
      var pendiente = 0;
      var pasada = 0;
      var noInicia = 0;
      var i;
      var el;
      for (i = 0; i < grupos.length; i++) {
        el = grupos[i];
        if (this.listaPasada(el)) pasada += 1;
        else if (this.claseIniciadaSinLista(el)) pendiente += 1;
        else if (this.grupoTieneClaseHoy(el) && !this.claseYaInicio(el)) noInicia += 1;
      }
      return {
        todos: grupos.length,
        pendiente: pendiente,
        pasada: pasada,
        no_inicia: noInicia,
      };
    },

    filterGrupos: function () {
      var grupos = this.gruposFiltradosBase;

      if (this.filtroLista === 'pendiente') {
        grupos = grupos.filter(function (el) {
          return this.claseIniciadaSinLista(el);
        }, this);
      } else if (this.filtroLista === 'pasada') {
        grupos = grupos.filter(function (el) {
          return this.listaPasada(el);
        }, this);
      } else if (this.filtroLista === 'no_inicia') {
        grupos = grupos.filter(function (el) {
          return this.grupoTieneClaseHoy(el) && !this.claseYaInicio(el);
        }, this);
      }

      return grupos;
    },
  },

  watch: {
    ciclo: function () {
      if (this._restaurandoEstado) return;
      if (this.ciclo) {
        this.consultar(false);
      } else {
        this.gruposRoles = [];
        this.niveles = [];
        this.teachersLista = [];
        this.mensajeGrupos = '';
        this.cargarGrupos = false;
        this.consultaGruposId += 1;
        this.persistirEstado();
      }
    },
    plantel: function () {
      if (this._restaurandoEstado || !this.ciclo) return;
      this.aplicarFiltrosLocales();
    },
    teacherFiltro: function () {
      if (this._restaurandoEstado || !this.ciclo) return;
      this.aplicarFiltrosLocales();
    },
    fecha: async function () {
      if (this._restaurandoEstado) return;
      await this.consultarSiEsFechaExamen();
      if (this.grupo && this.dialogGrupo) {
        await this.getAlumnos(this.grupo, false);
      }
    },
  },

  created: function () {
    this.headers = this.headersParticipacion;
    this.initialize();
    this.ahoraMinutos = this.minutosAhora();
    this.intervaloHora = setInterval(function () {
      this.ahoraMinutos = this.minutosAhora();
    }.bind(this), 30000);
  },

  beforeDestroy: function () {
    clearTimeout(participacionPersistTimer);
    if (this.intervaloHora) clearInterval(this.intervaloHora);
    this.persistirEstado(true);
  },

  methods: {
    minutosAhora: function () {
      var d = new Date();
      return d.getHours() * 60 + d.getMinutes();
    },

    minutosDesdeHora: function (hora) {
      if (!hora) return null;
      var partes = String(hora).trim().replace('_', ':').split(':');
      var h = parseInt(partes[0], 10) || 0;
      var m = parseInt(partes[1], 10) || 0;
      return h * 60 + m;
    },

    grupoTieneClaseHoy: function (item) {
      if (!item) return false;
      if (item.clase_hoy === true || item.clase_hoy === 1) return true;
      if (item.clase_hoy === false || item.clase_hoy === 0) return false;
      var dia = new Date().getDay();
      var mapa = {
        0: item.domingo,
        1: item.lunes,
        2: item.martes,
        3: item.miercoles,
        4: item.jueves,
        5: item.viernes,
        6: item.sabado,
      };
      return Number(mapa[dia]) === 1;
    },

    claseYaInicio: function (item) {
      var mins = this.minutosDesdeHora(item && item.hora_inicio);
      if (mins == null) return false;
      return this.ahoraMinutos >= mins;
    },

    listaPasada: function (item) {
      if (!item) return false;
      if (item.lista_pasada) return true;
      return this.grupoTieneClaseHoy(item) && Number(item.registros_hoy) > 0;
    },

    claseIniciadaSinLista: function (item) {
      return this.grupoTieneClaseHoy(item) && this.claseYaInicio(item) && !this.listaPasada(item);
    },

    claseFilaGrupo: function (item) {
      if (this.listaPasada(item)) return 'fila-lista-pasada';
      if (this.claseIniciadaSinLista(item)) return 'fila-lista-pendiente';
      return '';
    },

    claseFilaAlumno: function (item) {
      if (!item || item.tipo == 1) return '';
      var v = Number(item.valor_asistencia);
      if (v === 1) return 'fila-asistio';
      if (v === 2) return 'fila-falto';
      if (v === 4) return 'fila-justificada';
      return '';
    },

    actualizarConteosGrupo: function () {
      if (!this.grupo) return;
      var alumnos = this.listaalumnos.filter(function (a) {
        return a && a.id;
      });
      var asist = 0;
      var faltas = 0;
      var just = 0;
      alumnos.forEach(function (a) {
        var v = Number(a.valor_asistencia);
        if (v === 1) asist += 1;
        else if (v === 2) faltas += 1;
        else if (v === 4) just += 1;
      });
      this.$set(this.grupo, 'asistencias_hoy', asist);
      this.$set(this.grupo, 'faltas_hoy', faltas);
      this.$set(this.grupo, 'justificadas_hoy', just);
      this.$set(this.grupo, 'registros_hoy', alumnos.length);
      this.$set(this.grupo, 'lista_pasada', this.grupoTieneClaseHoy(this.grupo) && alumnos.length > 0);
    },

    teacherIdGuardar: function () {
      if (this.idTeacherLms) return Number(this.idTeacherLms);
      if (this.grupo && this.grupo.id_teacher_hoy) return Number(this.grupo.id_teacher_hoy);
      return 0;
    },

    tieneVistaAmpliadaLogin: function () {
      var u = this.getdatosUsuarioERPERP || {};
      var iderp = Number(u.iderp);
      var idpuesto = Number(u.idpuesto);
      if (iderp === 1177) return true;
      return [11, 12, 43].indexOf(idpuesto) !== -1;
    },

    initialize: function () {
      var self = this;
      var restaurado = this.restaurarEstadoPersistido();
      if (restaurado && this.ciclos.length) {
        this.cargandoCiclos = false;
        this._persistReady = true;
        return;
      }

      this.cargandoCiclos = true;
      this.ciclos = [];
      this.mensajeGrupos = '';
      this.$http
        .get('roles.ciclos.all')
        .then(function (response) {
          for (var i in response.data) {
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              if (response.data[i].ciclo.search('CICLO') != -1) {
                self.ciclos.push(response.data[i]);
              }
            }
          }
          self.restaurarUiDesdePersistencia();
          self.persistirEstado();
        })
        .catch(function (error) {
          self.validarError(self.obtenerMensajeError(error, 'No se pudieron cargar los ciclos'));
        })
        .finally(function () {
          self.cargandoCiclos = false;
          self._persistReady = true;
        });
    },

    restaurarEstadoPersistido: function () {
      try {
        var u = this.getdatosUsuarioERPERP || {};
        var raw = sessionStorage.getItem(participacionStorageKey(u.iderp));
        if (!raw) return false;

        var data = JSON.parse(raw);
        if (!data || !data.ts || Date.now() - data.ts > PARTICIPACION_CACHE_TTL_MS) {
          sessionStorage.removeItem(participacionStorageKey(u.iderp));
          return false;
        }

        this._restaurandoEstado = true;
        if (Array.isArray(data.ciclos) && data.ciclos.length) {
          this.ciclos = data.ciclos;
        }
        if (data.gruposBasePorCiclo && typeof data.gruposBasePorCiclo === 'object') {
          this.gruposBasePorCiclo = data.gruposBasePorCiclo;
        }
        if (data.ui) {
          this.plantel = data.ui.plantel != null ? data.ui.plantel : null;
          this.teacherFiltro = data.ui.teacherFiltro != null ? data.ui.teacherFiltro : null;
          this.curso = data.ui.curso != null ? data.ui.curso : null;
          this.modalidad = data.ui.modalidad != null ? data.ui.modalidad : null;
          this.nivel = data.ui.nivel != null ? data.ui.nivel : null;
          this.search = data.ui.search || '';
        }
        this.restaurarUiDesdePersistencia(data.ui);
        this._restaurandoEstado = false;
        return true;
      } catch (e) {
        this._restaurandoEstado = false;
        return false;
      }
    },

    restaurarUiDesdePersistencia: function (uiPersistido) {
      var ui = uiPersistido || null;
      if (!ui && this.ciclo) return;

      if (!ui) {
        try {
          var u = this.getdatosUsuarioERPERP || {};
          var raw = sessionStorage.getItem(participacionStorageKey(u.iderp));
          if (!raw) return;
          var data = JSON.parse(raw);
          ui = data && data.ui ? data.ui : null;
        } catch (e) {
          return;
        }
      }
      if (!ui || !this.ciclos.length) return;

      if (ui.id_ciclo) {
        var ciclo = this.ciclos.find(function (c) {
          return String(c.id_ciclo) === String(ui.id_ciclo) &&
            String(c.id_ciclo_relacionado || '') === String(ui.id_ciclo_relacionado || '');
        });
        if (ciclo) {
          this._restaurandoEstado = true;
          this.ciclo = ciclo;
          var cicloKey = this.getCicloStorageKey(ciclo);
          if (this.gruposBasePorCiclo[cicloKey]) {
            this.aplicarMetaDesdeBase(cicloKey);
            this.aplicarFiltrosLocales();
          }
          this._restaurandoEstado = false;
        }
      }
    },

    persistirEstado: function (inmediato) {
      var self = this;
      if (!self._persistReady || self._restaurandoEstado) return;

      var guardar = function () {
        try {
          var u = self.getdatosUsuarioERPERP || {};
          var payload = {
            ts: Date.now(),
            gruposBasePorCiclo: self.gruposBasePorCiclo,
            ciclos: self.ciclos,
            ui: {
              id_ciclo: self.ciclo && self.ciclo.id_ciclo,
              id_ciclo_relacionado: self.ciclo && self.ciclo.id_ciclo_relacionado,
              plantel: self.plantel,
              teacherFiltro: self.teacherFiltro,
              curso: self.curso,
              modalidad: self.modalidad,
              nivel: self.nivel,
              search: self.search,
            },
          };
          sessionStorage.setItem(participacionStorageKey(u.iderp), JSON.stringify(payload));
        } catch (e) {
          /* límite de sessionStorage */
        }
      };

      clearTimeout(participacionPersistTimer);
      if (inmediato) {
        guardar();
        return;
      }
      participacionPersistTimer = setTimeout(guardar, 400);
    },

    getGruposBaseLista: function () {
      if (!this.ciclo) return this.gruposRoles;
      var base = this.gruposBasePorCiclo[this.getCicloStorageKey(this.ciclo)];
      return base && Array.isArray(base.grupos) ? base.grupos : this.gruposRoles;
    },

    getConsultaApiPayload: function () {
      if (!this.ciclo) return {};
      return {
        id_ciclo: this.ciclo.id_ciclo,
        id_ciclo_relacionado: this.ciclo.id_ciclo_relacionado,
      };
    },

    grupoTieneTeacher: function (grupo, teacherId) {
      if (!teacherId || !grupo) return true;
      var id = Number(teacherId);
      var revisar = function (cadena) {
        if (!cadena) return false;
        return String(cadena).split(',').some(function (x) {
          var n = Number(x);
          return n > 0 && n === id;
        });
      };
      return revisar(grupo.teacher_ids) || revisar(grupo.teacher_ids_2);
    },

    aplicarMetaDesdeBase: function (cicloKey) {
      var base = this.gruposBasePorCiclo[cicloKey];
      if (!base || !base.meta) return;
      var meta = base.meta;
      this.puedeVerTodos = !!meta.puede_ver_todos;
      this.idTeacherLms = meta.id_teacher_lms || 0;
      this.teachersLista = Array.isArray(meta.teachers) ? meta.teachers : [];
      if (meta.tabla_asistencia) this.tablaAsistencia = meta.tabla_asistencia;
    },

    aplicarFiltrosLocales: function () {
      if (!this.ciclo) return;
      var cicloKey = this.getCicloStorageKey(this.ciclo);
      var base = this.gruposBasePorCiclo[cicloKey];
      if (!base) return;

      var grupos = (base.grupos || []).slice();

      if (this.plantel) {
        grupos = grupos.filter(function (g) {
          return Number(g.id_plantel) === Number(this.plantel);
        }, this);
      }

      if (this.mostrarFiltroTeacher && this.teacherFiltro) {
        grupos = grupos.filter(function (g) {
          return this.grupoTieneTeacher(g, this.teacherFiltro);
        }, this);
      }

      this.gruposRoles = grupos;
      this.niveles = grupos.map(function (registro) {
        return registro.id_nivel;
      });
      this.mensajeGrupos = grupos.length
        ? ''
        : 'El ciclo seleccionado no devolvió grupos para tu perfil';
      this.persistirEstado();
    },

    consultar: function (forzarRecarga) {
      var self = this;
      if (!this.ciclo) {
        return this.validarErrorDirecto('Selecciona un ciclo por favor');
      }

      var cicloKey = this.getCicloStorageKey(this.ciclo);
      if (!forzarRecarga && this.gruposBasePorCiclo[cicloKey]) {
        this.aplicarMetaDesdeBase(cicloKey);
        this.aplicarFiltrosLocales();
        return Promise.resolve(this.gruposRoles);
      }

      var requestId = ++this.consultaGruposId;
      this.gruposRoles = [];
      this.niveles = [];
      this.mensajeGrupos = '';
      this.cargarGrupos = true;

      return this.$http
        .post('participacion.alumnos.grupos', this.getConsultaApiPayload())
        .then(function (response) {
          if (requestId !== self.consultaGruposId) return;

          var data = response.data || {};
          var grupos = Array.isArray(data.respuesta) ? data.respuesta : [];
          var meta = data.meta || {};

          self.$set(self.gruposBasePorCiclo, cicloKey, {
            grupos: grupos,
            meta: meta,
          });
          self.aplicarMetaDesdeBase(cicloKey);
          self.aplicarFiltrosLocales();
          self.persistirEstado();
        })
        .catch(function (error) {
          if (requestId !== self.consultaGruposId) return;
          self.mensajeGrupos = self.obtenerMensajeError(error, 'No se pudieron cargar los grupos');
          self.validarError(self.mensajeGrupos);
        })
        .finally(function () {
          if (requestId === self.consultaGruposId) self.cargarGrupos = false;
        });
    },

    getCicloStorageKey: function (ciclo) {
      if (!ciclo) return '';
      return [
        ciclo.id_ciclo || '',
        ciclo.id_ciclo_relacionado || '',
      ].join(':');
    },

    invalidarAsistenciasGrupo: function (item) {
      if (!item) return;
      var prefijo = String(item.id_grupo_lms) + ':';
      var escuela = String(item.id_unidad_negocio);
      Object.keys(this.asistenciasCache).forEach(function (key) {
        if (key.indexOf(prefijo) === 0 && key.endsWith(':' + escuela)) {
          delete this.asistenciasCache[key];
        }
      }, this);
    },

    getAsistenciasCacheKey: function (item) {
      return [
        item.id_grupo_lms,
        this.fecha,
        item.id_unidad_negocio,
      ].join(':');
    },

    getFechasCacheKey: function (item) {
      return [
        item.id_grupo_lms,
        item.id_nivel,
        item.id_unidad_negocio,
      ].join(':');
    },

    obtenerMensajeError: function (error, mensajeDefault) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
      }
      return mensajeDefault;
    },

    verGrupo: async function (item) {
      this.modalEscuela = item.grupo.includes('FAST') ? 2 : 1;
      this.modalIdgrupo = item.id_grupo_lms;
      this.grupo = item;
      await this.getConsultarFechas(item);
      await this.consultarSiEsFechaExamen();
      await this.getAlumnos(item);
      this.dialogGrupo = true;
    },

    getAlumnos: function (item, forzarRecarga) {
      var self = this;
      var cacheKey = this.getAsistenciasCacheKey(item);
      if (!forzarRecarga && this.asistenciasCache[cacheKey]) {
        this.listaalumnos = this.asistenciasCache[cacheKey].slice();
        this.disabled = false;
        return Promise.resolve(this.listaalumnos);
      }

      this.listaalumnos = [];
      this.cargar = true;
      var payload = {
        id_grupo: item.id_grupo_lms,
        fecha: this.fecha,
        id_nivel: item.id_nivel,
        escuela: item.id_unidad_negocio,
      };
      return this.$http
        .post('participacion.alumnos.asistencias', payload)
        .then(function (response) {
          response.data.map(function (a) {
            a.valorAsistenciaInicial = a.valor_asistencia;
          });
          var filas = response.data.slice();
          filas.unshift({ alumno: 'Valor', asistencia: '', tipo: 1 });
          self.$set(self.asistenciasCache, cacheKey, filas);
          self.listaalumnos = filas.slice();
          self.disabled = false;
        })
        .catch(function (error) {
          self.disabled = true;
          var msg = self.obtenerMensajeError(error, 'No se pudieron cargar las asistencias');
          self.validarError(msg);
        })
        .finally(function () {
          self.cargar = false;
        });
    },

    getConsultarFechas: function (item) {
      var self = this;
      var cacheKey = this.getFechasCacheKey(item);
      if (this.fechasCache[cacheKey]) {
        var cached = this.fechasCache[cacheKey];
        this.fechaMin = cached.fechaMin;
        this.fechaMax = cached.fechaMax;
        this.fechas = cached.fechas.slice();
        this.fecha = cached.fecha;
        return Promise.resolve(this.fechas);
      }

      this.cargar = true;
      var payload = {
        id_grupo: item.id_grupo_lms,
        id_nivel: item.id_nivel,
        escuela: item.id_unidad_negocio,
      };
      this.fechas = [];
      return this.$http
        .post('grupos.fechas.habiles', payload)
        .then(function (response) {
          var fechas = response.data || [];
          var fechaMin = fechas[0];
          var fechaMax = fechas[fechas.length - 1];
          var fecha = fechaMax;
          self.fechaMin = fechaMin;
          self.fechaMax = fechaMax;
          self.fechas = fechas;
          self.fecha = fecha;
          self.$set(self.fechasCache, cacheKey, {
            fechaMin: fechaMin,
            fechaMax: fechaMax,
            fechas: fechas,
            fecha: fecha,
          });
        })
        .catch(function (error) {
          self.disabled = true;
          self.validarError(self.obtenerMensajeError(error, 'No se pudieron cargar las fechas'));
        })
        .finally(function () {
          self.cargar = false;
        });
    },

    exportar: function () {
      var filas = this.filterGrupos.map(function (g) {
        return {
          Grupo: g.grupo,
          Horario: g.horario || '',
          Teacher: g.teacher_hoy || g.teachers_nombre || '',
          Alumnos: g.cant_alumnos,
          Asistencias: Number(g.asistencias_hoy) || 0,
          Faltas: Number(g.faltas_hoy) || 0,
          Lista: this.listaPasada(g)
            ? 'Con lista'
            : this.claseIniciadaSinLista(g)
              ? 'Sin lista'
              : this.grupoTieneClaseHoy(g) && !this.claseYaInicio(g)
                ? 'Aún no inicia'
                : '',
          Plantel: g.plantel || '',
          Nivel: g.id_nivel,
        };
      }, this);
      this.exportExcel(filas, 'PARTICIPACION_ALUMNOS');
    },

    fechasHabiles: function (val) {
      return this.fechas.includes(val);
    },

    enviarAsistencias: function () {
      var self = this;
      this.cargar = true;
      var asistencias = this.listaalumnos.filter(function (alumno) {
        return alumno && alumno.id;
      });
      var payload = {
        id_grupo: this.grupo.id_grupo_lms,
        fecha: this.fecha,
        id_nivel: this.grupo.id_nivel,
        asistencias: asistencias,
        id_teacher: this.teacherIdGuardar(),
        escuela: this.grupo.id_unidad_negocio,
      };
      this.$http
        .post('participacion.alumnos.asistencias.add', payload)
        .then(function (response) {
          if (response.data && response.data.id_teacher) {
            self.idTeacherLms = response.data.id_teacher;
          }
          self.parametros.mensaje = response.data.message;
          self.parametros.dialogError = true;
          self.parametros.color = 'success';
          self.respuestaAlerta = true;
          self.invalidarAsistenciasGrupo(self.grupo);
          self.getAlumnos(self.grupo, true).then(function () {
            self.actualizarConteosGrupo();
          });
        })
        .catch(function (error) {
          self.validarError(self.obtenerMensajeError(error, 'No se pudo guardar la asistencia'));
        })
        .finally(function () {
          self.cargar = false;
        });
    },

    guardarAsistenciaAlumno: function (item) {
      var payload = {
        id_grupo: this.grupo.id_grupo_lms,
        fecha: this.fecha,
        id_nivel: this.grupo.id_nivel,
        asistencias: [item],
        id_teacher: this.teacherIdGuardar(),
        escuela: this.grupo.id_unidad_negocio,
      };
      return this.$http.post('participacion.alumnos.asistencias.add', payload);
    },

    consultarSiEsFechaExamen: async function () {
      this.modalSesion = 0;
      this.mostrarBtnAsistencia = false;
      var payload = {
        id_grupo: this.modalIdgrupo,
        escuela: this.modalEscuela,
        fecha: this.fecha,
      };
      var esFechaExamen = await this.esFechaExamen(payload);
      if (esFechaExamen && esFechaExamen.data) {
        this.modalSesion = esFechaExamen.data.sesion;
        this.mostrarBtnAsistencia = esFechaExamen.data.fecha;
      }
    },

    onJustificacionCerrada: function () {
      this.invalidarAsistenciasGrupo(this.grupo);
      this.getAlumnos(this.grupo, true);
    },

    justificar: async function (item) {
      if (Number(item.valor_asistencia) !== 2 && Number(item.valor_asistencia) !== 4) return;

      if (Number(item.valor_asistencia) === 2) {
        this.cargar = true;
        try {
          await this.guardarAsistenciaAlumno(item);
          this.invalidarAsistenciasGrupo(this.grupo);
          await this.getAlumnos(this.grupo, true);
          var alumnoGuardado = this.listaalumnos.find(function (alumno) {
            return alumno.id === item.id;
          });
          if (alumnoGuardado) item = alumnoGuardado;
        } catch (error) {
          this.validarError(this.obtenerMensajeError(error, 'No se pudo guardar la falta antes de justificar'));
          return;
        } finally {
          this.cargar = false;
        }
      }

      this.modalIderp = item.iderp;
      var payloadJust = {
        iderp: item.iderp,
        id_grupo: this.modalIdgrupo,
        escuela: this.modalEscuela,
        fecha: this.fecha,
      };
      this.modalId_usuario = item.id;
      if (Number(item.valor_asistencia) === 4) {
        this.modalJustificacion = await this.verificarSiPuedeHacerJustificacion(payloadJust);
      } else {
        this.modalJustificacion = false;
      }
      this.modalJustificarAsistencia.status = true;
    },
  },
};
</script>

<style scoped>
.asistencia-page {
  max-width: 1400px;
}
.page-card {
  border-radius: 12px;
  overflow: hidden;
}
.page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.page-title {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
}
.page-subtitle {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}
.page-subtitle__dot {
  margin: 0 4px;
}
.page-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.page-actions__btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
}
.filters-row >>> .v-input {
  font-size: 0.875rem;
}
.asistencia-table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}
.asistencia-table >>> thead th {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.6) !important;
  background: #fafafa !important;
}
.dialog-card {
  border-radius: 12px;
}
.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.dialog-title {
  font-size: 1rem;
  font-weight: 600;
}
.dialog-subtitle {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 2px;
}
.dialog-table {
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.asistencia-table >>> tbody tr.fila-lista-pendiente {
  background: #ffcdd2 !important;
}
.asistencia-table >>> tbody tr.fila-lista-pasada {
  background: #c8e6c9 !important;
}
.asistencia-table >>> tbody tr.fila-asistio {
  background: #e8f5e9 !important;
}
.asistencia-table >>> tbody tr.fila-falto {
  background: #ffebee !important;
}
.asistencia-table >>> tbody tr.fila-justificada {
  background: #fff3e0 !important;
}
.asistencia-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
}
.asistencia-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #babcbf;
  border-radius: 8px;
}
</style>
